import { render, staticRenderFns } from "./ConceptSelector.vue?vue&type=template&id=12977ab8&scoped=true"
import script from "./ConceptSelector.vue?vue&type=script&lang=js"
export * from "./ConceptSelector.vue?vue&type=script&lang=js"
import style0 from "./ConceptSelector.vue?vue&type=style&index=0&id=12977ab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../makeup-web/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12977ab8",
  null
  
)

export default component.exports